export const CHANGE_LOADING_TRUE = 'CHANGE_LOADED_TRUE';
export const CHANGE_LOADING_FALSE = 'CHANGE_LOADED_FALSE';

export function changeLoadingTrue() {
  return {
    type: CHANGE_LOADING_TRUE,
  };
}

export function changeLoadingFalse() {
  return {
    type: CHANGE_LOADING_FALSE,
  };
}
